import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=64f31c7c&scoped=true&"
import script from "./Contact.js?vue&type=script&lang=js&"
export * from "./Contact.js?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=64f31c7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f31c7c",
  null
  
)

export default component.exports